var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('H4',[_vm._v("Reports VIEW FOR SENIOR! NEEDS WORK!!!")]),_c('b-card',[_c('b-tabs',[_c('b-tab',{attrs:{"title":"Report1"}},[_vm._v("1")]),_c('b-tab',{attrs:{"title":"Report2"}},[_vm._v("2")]),_c('b-tab',{attrs:{"title":"Report3"}},[_vm._v("3")]),_c('b-tab',{attrs:{"title":"Report4"}},[_vm._v("4")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }